module.exports = __webpack_public_path__ + "static/img/preview-04.622a7091.webp";